import { render, staticRenderFns } from "./Examinations.vue?vue&type=template&id=1d133252&scoped=true"
import script from "./Examinations.vue?vue&type=script&lang=js"
export * from "./Examinations.vue?vue&type=script&lang=js"
import style0 from "./Examinations.vue?vue&type=style&index=0&id=1d133252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d133252",
  null
  
)

export default component.exports